export class AuthTokenModel {
    public userName: string;
    public userToken: string;
    public UserTokenExpiresIn: number;
    public isUserTokenValid: boolean;
    public tokenMessage: string;
    public userId: number;
    public loginId: string;
    public userRole: string;
}